import {
  CIVILPROGRESSION_LOADING,
  GET_CIVILPROGRESSION,
  GET_CIVILPROGRESSION_SUCCESS,
  GET_CIVILPROGRESSION_FAIL,
  ADD_CIVILPROGRESSION_SUCCESS,
  ADD_CIVILPROGRESSION_FAIL,
  DELETE_CIVILPROGRESSION_SUCCESS,
  DELETE_CIVILPROGRESSION_FAIL,
  UPDATE_CIVILPROGRESSION_SUCCESS,
  UPDATE_CIVILPROGRESSION_FAIL,
  CIVILPROGRESSION_RESET
} from "./actionType";

const INIT_STATE = {
  civilProgressions: [],
  error: {},
};

const CivilProgression = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILPROGRESSION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILPROGRESSION:
          return {
            ...state,
            civilProgressions: action.payload.data,
            isCivilProgressionCreated: false,
            isCivilProgressionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILPROGRESSION_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILPROGRESSION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilProgressionCreated: false,
            isCivilProgressionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILPROGRESSION: {
      return {
        ...state,
        isCivilProgressionCreated: false,
        loading: true,
      };
    }

    case CIVILPROGRESSION_LOADING: {
      return {
        ...state,
        isCivilProgressionCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILPROGRESSION_SUCCESS:
      return {
        ...state,
        isCivilProgressionCreated: true,
        loading: false,
        civilProgressions: [action.payload.data, ...state.civilProgressions],
      };

    case ADD_CIVILPROGRESSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILPROGRESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        civilProgressions: state.civilProgressions.filter(
          civilCivilProgression => civilCivilProgression.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILPROGRESSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILPROGRESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        civilProgressions: state.civilProgressions.map(civilCivilProgression =>
          civilCivilProgression.id.toString() === action.payload.data.id.toString() ? { ...civilCivilProgression, ...action.payload.data } : civilCivilProgression
        ),
      };

    case UPDATE_CIVILPROGRESSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILPROGRESSION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilProgression;